var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{class:'license-status ' + _vm.status,attrs:{"icon":"check","disabled":true,"block":"","large":"","outline":""}},[_vm._v("\n    "+_vm._s(_vm.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }